<div class="wrap">
  <h2>{{data.title}}</h2>
  <!-- <ng-container [ngSwitch]="data.action"> -->
  <form *ngIf="itemForm && !isLoading" [formGroup]="itemForm" (submit)="onSubmit()">

    <mat-form-field appearance="outline">
      <mat-label>Label {{data.type === 'tag'? 'du' : 'de la' }} {{data.type}}</mat-label>
      <input type="text" matInput formControlName="item">
    </mat-form-field>

    <mat-form-field class="universesField" appearance="outline" *ngIf="data.type === 'categorie'">
      <mat-label>Univers</mat-label>
      <mat-select formControlName="universes" multiple>
        <mat-option *ngFor="let universe of universes"
          [value]="universe.universeKey">{{universe.universeName}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="data.type === 'tag'">
      <mat-label>Couleur</mat-label>
      <mat-select [(value)]="selected">
        <mat-option *ngFor="let c of colors" [value]="c">
          <span> {{c.name}}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="btn_action">
      <button type="button" class="back" (click)="dialogRef.close()">Annuler</button>
      <button type="submit" class="confirm" [disabled]="itemForm.invalid || itemForm.pristine"
        [style.opacity]="itemForm.invalid || itemForm.pristine ? .5 : 1">
        {{data.action === 'add' ? 'Ajouter' :
        'Modifier'}}</button>
    </div>

  </form>
  <!-- </ng-container> -->
</div>